import React from 'react';
import { Row, Col } from 'antd';
import history from '../../../../../../../../history/history';
import {
  ReceiptsWrapper,
  NoData,
  ViewAll,
} from './styles';
import PropTypes from 'prop-types';
import { UnderlineLink } from '../../../../../../../../CommonComponents/commonStyles';
import DocumentCard from '../../../../../../../../CommonComponents/Cards/DocumentCard/DocumentCard';

function redirectPage(path) {
  history.push(path);
}

function renderReceipts(receipts, handleViewAnalytics, mob) {
  if (receipts.length !== 0) {
    const allReceipts = receipts.map((receipt, index) => (
      <DocumentCard
        data-test="receipt-action"
        key={receipt.id}
        indexKey={`${receipt.id}${index}${mob ? 'mob' : ''}`}
        newIcon={false}
        receipt={receipt}
        handleViewAnalytics={handleViewAnalytics}
      />
    ));
    return (
      <React.Fragment>
        {allReceipts}
        <ViewAll rMargin='20px' bMargin='0'>
          <UnderlineLink
            id={`anrViewAll${mob ? 'mob' : ''}`}
            onClick={() => redirectPage('/my-account/my-documents')}
          >
            View All
          </UnderlineLink>
        </ViewAll>
      </React.Fragment>
    );
  } else {
    return <NoData>You currently have no recent tax receipts</NoData>;
  }
}

const Receipts = ({ taxReceipts, handleViewAnalytics }) => {
  const receipts = (mob) => renderReceipts(taxReceipts, handleViewAnalytics, mob);
  return (
    <Row>
      <Col lg={24} md={24} xs={0}>
        <ReceiptsWrapper overflow={'y'} height='135px'>
          {receipts('')}
        </ReceiptsWrapper>
      </Col>
      <Col lg={0} md={0} xs={24}>
        <ReceiptsWrapper
          overflow={'x'}
          height={taxReceipts.length === 0 ? '120px' : '395px'}
          isData={taxReceipts.length === 0}
        >
          {receipts('mob')}
        </ReceiptsWrapper>
      </Col>
    </Row>
  );
};

export default Receipts;

Receipts.propTypes = {
  receipts: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.number,
      id: PropTypes.string,
      link: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  handleViewAnalytics: PropTypes.func,
};
